import src from "IMAGE";
export default { src, width: 32, height: 32 }
